import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FooterActions } from "../../../Store/Footer/action";
import HeaderBackground from "../../../common/SubpagesBGimage";

function ReportsFooter() {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Final list of tabs to display (only those with data)
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const [activeYear, setActiveYear] = useState("");
  const [years, setYears] = useState([]);
  const [subtitle, setSubtitle] = useState("");
  const [reportLinks, setReportLinks] = useState([]);

  // --- Validation Process States ---
  const [allTitles, setAllTitles] = useState([]);
  const [checkIndex, setCheckIndex] = useState(0);
  const [isValidating, setIsValidating] = useState(false);

  const { ReportsTitle, ReportsData } = useSelector(
    (state) => state.FooterReducer
  );

  const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);

  // 1. Fetch Report Titles on Load
  useEffect(() => {
    dispatch({ type: FooterActions.GET_REPORTS_TITLE });
  }, [dispatch]);

  // 2. When Titles arrive, start the validation process
  useEffect(() => {
    if (ReportsTitle?.data?.length > 0) {
      setAllTitles(ReportsTitle.data);
      setTabs([]);
      setCheckIndex(0);
      setIsValidating(true);
    }
  }, [ReportsTitle]);

  // 3. Trigger Fetch for the current index
  useEffect(() => {
    if (isValidating && allTitles.length > 0 && checkIndex < allTitles.length) {
      const currentTitle = allTitles[checkIndex];

      dispatch({
        type: FooterActions.GET_REPORTS_DATA,
        payload: { id: currentTitle.id },
      });
    }

    if (isValidating && checkIndex >= allTitles.length && allTitles.length > 0) {
      setIsValidating(false);
      if (tabs.length === 0) {
        // console.log("No reports available");
      }
    }
  }, [checkIndex, isValidating, allTitles, dispatch]);

  // 4. Analyze the Response Data
  useEffect(() => {
    if (!isValidating) return;
    if (!allTitles[checkIndex]) return;

    const currentTitle = allTitles[checkIndex];
    if (ReportsData && ReportsData.length > 0) {
      const newTab = {
        id: `tabs-${currentTitle.id}`,
        name: currentTitle.title,
        itemId: currentTitle.id,
      };
      setTabs((prev) => [...prev, newTab]);
      if (tabs.length === 0) {
        setActiveTab(newTab.id);
        updateReportUI(ReportsData);
      }
    }

    const timer = setTimeout(() => {
      setCheckIndex((prev) => prev + 1);
    }, 100);

    return () => clearTimeout(timer);

  }, [ReportsData, isValidating]);

  // Helper to update Year/Link UI
  const updateReportUI = (data) => {
    if (!data || data.length === 0) return;

    const yearsList = data.map((d) => ({
      year: d.year,
      subtitle: d.subtitle,
      text_1: d.text_1,
      pdf_1: d.pdf_1,
      text_2: d.text_2,
      pdf_2: d.pdf_2,
      text_3: d.text_3,
      pdf_3: d.pdf_3,
    }));

    setYears(yearsList.map((y) => y.year));
    const latestYearData = yearsList[0];
    setActiveYear(latestYearData.year);
    setSubtitle(latestYearData.subtitle);
    setReportLinks([
      { text: latestYearData.text_1, pdf: latestYearData.pdf_1 },
      { text: latestYearData.text_2, pdf: latestYearData.pdf_2 },
      { text: latestYearData.text_3, pdf: latestYearData.pdf_3 },
    ]);
  };

  // Handle Year Click
  const handleYearClick = (year) => {
    setActiveYear(year);
    const selectedYearData = ReportsData.find((data) => data.year === year);
    if (selectedYearData) {
      setSubtitle(selectedYearData.subtitle);
      setReportLinks([
        { text: selectedYearData.text_1, pdf: selectedYearData.pdf_1 },
        { text: selectedYearData.text_2, pdf: selectedYearData.pdf_2 },
        { text: selectedYearData.text_3, pdf: selectedYearData.pdf_3 },
      ]);
    }
  };

  // Handle Tab Click (Normal usage after initial load)
  const handleTabClick = (tabId, itemId) => {
    setActiveTab(tabId);
    dispatch({
      type: FooterActions.GET_REPORTS_DATA,
      payload: { id: itemId },
    });
  };

  // Effect for normal tab clicks (after validation is done)
  useEffect(() => {
    if (!isValidating && ReportsData && ReportsData.length > 0) {
      updateReportUI(ReportsData);
    }
  }, [ReportsData, isValidating]);

  return (
    <div>
      <HeaderBackground menuName="Footer" handleMenuToggle={handleMenuToggle} />
      <section className="services-tab section-padding mb-80">
        <div className="container">
          <div className="cal-action pb-10 mb-40">
            <div className="bord d-flex align-items-center">
              <h1 className="fw-300 heading-submenu-res core-fac-heading-res overall-submenu-heading">Reports</h1>
            </div>
          </div>

          {/* Small Screen Titles */}
          <div className="col-lg-12 small-screen-titles">
            <ul className="rest">
              {tabs.map((tab, index) => (
                <li
                  key={tab.id}
                  className={`item-link mb-15 go-moreee-tabs go-more-psg-iap go-more-psg-iap-line1 ${activeTab === tab.id ? "current" : ""
                    }`}
                  onClick={() => handleTabClick(tab.id, tab.itemId)}
                >
                  <h5>
                    <span className="fz-18 opacity-7 mr-15">{`0${index + 1}`}</span>
                    {tab.name}
                  </h5>
                </li>
              ))}
            </ul>
          </div>

          <div className="row lg-marg" id="tabs">
            {/* Large Screen Titles */}
            <div className="col-lg-4 large-screen-titles" style={{ marginTop: "-50px" }}>
              <div className="serv-tab-link tab-links full-width pt-40">
                <ul className="rest">
                  {tabs.map((tab, index) => (
                    <li
                      key={tab.id}
                      className={`item-link mb-15 go-moreee-tabs go-more-psg-iap go-more-psg-iap-line1 ${activeTab === tab.id ? "current" : ""
                        }`}
                      onClick={() => handleTabClick(tab.id, tab.itemId)}
                    >
                      <div className="u-line linee">
                        <span className="icon ti-arrow-circle-right"></span>
                        <span className="text fz-18 psg-margin">{tab.name}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Tab Content */}
            <div className="col-lg-8 col-12">
              <div className="md-mb80">
                <h5 style={{ color: "rgb(58, 65, 151)" }} className="mt-4">
                  {subtitle}
                </h5>

                {years.length > 0 && (
                  <ul className="nav nav-tabs" id="year-tabs" role="tablist">
                    {years.map((year) => (
                      <li key={year} className="nav-item">
                        <button
                          className={`nav-link ${activeYear === year ? "active" : ""}`}
                          onClick={() => handleYearClick(year)}
                        >
                          {year}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}

                <table className="table table-bordered custom-table">
                  <tbody>
                    {reportLinks.map(
                      (link, index) =>
                        link.text &&
                        link.pdf && (
                          <tr key={index}>
                            <td>
                              <a
                                href={link.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.text}{" "}
                                <i
                                  className="fa fa-file-pdf-o"
                                  aria-hidden="true"
                                  style={{
                                    fontSize: "16px",
                                    color: "brown",
                                  }}
                                ></i>
                              </a>
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ReportsFooter;